import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Safely convert a nullable string to a non-null string
 * @param value The string value which may be null or undefined
 * @param defaultValue Optional default value to use if null/undefined (defaults to empty string)
 * @returns A guaranteed non-null string
 */
export function safeString(value: string | null | undefined, defaultValue = ''): string {
  return value !== null && value !== undefined ? value : defaultValue;
}

export function safeEval(expr: string): number {
  if (expr.trim() === '') {
    return NaN;
  }
  try {
    // Replace x and ÷ with * and /
    const sanitized = expr.replace(/x/g, '*').replace(/÷/g, '/');
    // eslint-disable-next-line no-eval
    const result = eval(sanitized);
    if (typeof result !== 'number') {
      return NaN;
    }
    // Round to a reasonable number of decimal places to handle floating point inaccuracies
    return parseFloat(result.toPrecision(12));
  } catch {
    return NaN;
  }
}